import Quill from "quill";

const Embed = Quill.import("blots/embed");

export class CustomBreak extends Embed {
  static blotName = "custombreak";
  static tagName = "br";
  static className = "custombr";
}
